import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { HttpParams } from "@angular/common/http";
import { Params, Router } from "@angular/router";
import Swal from "sweetalert2";
import { ReportsService } from "src/app/features/consumer-report/reports.service";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { DialogComponent } from "src/app/features-common/components/dialog/dialog.component";
import { MatTabGroup } from "@angular/material/tabs";
import { CurrencyPipe, formatDate } from "@angular/common";
import * as moment from "moment";
import { AdminViewService } from "src/app/framework/services/admin-view.service";

@Component({
  selector: "app-consumer-acquisition",
  templateUrl: "./consumer-acquisition.component.html",
  styleUrls: ["./consumer-acquisition.component.scss"],
  providers: [CurrencyPipe],
})
export class ConsumerAcquisitionComponent
  extends FeaturesBaseComponent
  implements OnInit
{
  @Input() reatileracquisition;
  @Input() summary;

  isRowSelected: boolean = false;
  searchValue: any;

  columnDefs: any;
  rowData: any = [];
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  isLogSelected: boolean;
  //summary:  Array<any>;
  minFromDate;
  maxDate;
  minToDate;
  startDate;
  endDate;
  isButtonDisabled:boolean
  

  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private currencyPipe: CurrencyPipe,
    private adminViewServices:AdminViewService
  ) {
    super();
    this.setGrid();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["reatileracquisition"]) {
      this.reatileracquisition = changes["reatileracquisition"].currentValue;
      this.rowData = this.reatileracquisition;
      this.rowData = this.rowData.map((item) => {
        return {
          ...item,
          createTime: item.createDttm,
        };
      });
    }
    if (changes["summary"]) {
      this.summary = changes["summary"].currentValue;
    }
  }

  setGrid() {
    this.columnDefs = [
      {
        field: "createDttm",
        headerName: "Since (Date)",
        width: 180,
        cellRenderer: (data) => {
          return moment(data.value).format("MM/DD/YYYY");
        },
      },
      {
        field: "createTime",
        headerName: "Since (Time)",
        width: 180,
        cellRenderer: (data) => {
          return moment(data.value).format("hh:mm:ss:a");
        },
      },
      { field: "consumerName", headerName: "Consumer Name", width: 180 },
      {
        field: "consumerNumber",
        headerName: "Consumer Mobile Number",
        width: 300,
        cellRenderer: (data) => {
          if(data.value) {
            let formatNumber = data.value.slice(1)
            return  formatNumber;
          }
        },
      },
      //
      { field: "email", headerName: "Email Id", width: 180 },
    ];
  }

  formatMobileNumber(params: any): string {
    const phoneNumber = params;
    if (!phoneNumber) {
      return "";
    }

    if (phoneNumber.startsWith("+1")) {
      return phoneNumber.substring(2);
    }

    // Format mobile number (e.g., (123) 456-7890)
    const formatted = phoneNumber.replace(
      /(\d{3})(\d{3})(\d{4})/,
      "($1) $2-$3"
    );
    return formatted;
  }

  exportData() {
    let header = this.columnDefs.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "Consumer-Acquisition.csv",
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs
        .map((c) => c.field || c.colId)
        .filter((c) => !!c),
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      if (cellParams && cellParams.column.colId === "") {
        return "";
      } else if (cellParams && cellParams.column.colId === "createDttm") {
        return moment(cellParams.value).format("MM/DD/YYYY");
      } else if (cellParams && cellParams.column.colId === "createTime") {
        return moment(cellParams.value).format("hh:mm:ss:a");
      } else if (cellParams && cellParams.column.colId === "consumerNumber") {
        return this.formatMobileNumber(cellParams.value);
      } else return cellParams.value; // no formatting
    };
    this.gridApi.exportDataAsCsv(params);
  }
  ngOnInit(): void {
    super.ngOnInit();
     this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.rowData = this.rowData.map((item) => {
      return {
        ...item,
        createTime: item.createDttm,
      };
    });
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (
      this.selectedRows &&
      this.selectedRows != [] &&
      this.selectedRows.length! > 0
    ) {
      this.isLogSelected = true;
      return;
    }
    this.isLogSelected = false;
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.startDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.endDate != null && this.endDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  changeToDate(e) {
    this.endDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.startDate != null && this.startDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  getDateChangeResult(startDate, endDate) {
    let params: any = new HttpParams()
      .set("startDate", startDate)
      .set("endDate", endDate);
    this.reportsService
      .getreatileracquisitionSummary(params)
      .subscribe((res) => {
        let resData: any = res;
        if (resData.httpcode == 200) {
          resData = resData.data;
          this.summary = resData;
          this.reportsService
            .getreatileracquisition(params)
            .subscribe((res) => {
              let resData: any = res;
              if (resData.httpcode == 200) {
                resData = resData.data;
                this.setRowData(res["data"]);
                this.reatileracquisition = resData;
              }
            });
        }
      });
  }

  setRowData(rowData: any) {
    this.rowData = rowData;
    this.rowData = this.rowData.map((item) => {
      return {
        ...item,
        createTime: item.createDttm,
      };
    });
  }
}
